module.exports = __webpack_public_path__ + "media/images/landing/ar/create-bf103b848035da5a4344d39ed08178c6.webp";